const encoder = new TextEncoder();
export async function sha256Hex(input) {
    const digest = await crypto.subtle.digest("SHA-256", encoder.encode(input));
    return bytesToHex(new Uint8Array(digest));
}
export async function signRequest(secret, parts) {
    const key = await crypto.subtle.importKey("raw", encoder.encode(secret), { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
    const canonical = await canonicalRequest(parts);
    const signature = await crypto.subtle.sign("HMAC", key, encoder.encode(canonical));
    return base64UrlEncode(new Uint8Array(signature));
}
export async function verifySignature(secret, parts, signature) {
    const expected = await signRequest(secret, parts);
    return timingSafeEqual(expected, signature);
}
export async function canonicalRequest(parts) {
    const bodyHash = await sha256Hex(parts.body);
    return [
        parts.method.toUpperCase(),
        parts.path,
        bodyHash,
        parts.timestamp,
        parts.nonce,
    ].join("\n");
}
export function makeNonce() {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    return base64UrlEncode(bytes);
}
export function signatureHeaders(headers) {
    const timestamp = headers.get("x-dashboard-timestamp");
    const nonce = headers.get("x-dashboard-nonce");
    const signature = headers.get("x-dashboard-signature");
    if (!timestamp || !nonce || !signature)
        return null;
    return { timestamp, nonce, signature };
}
export function timestampWithinWindow(timestamp, windowSeconds, now = Date.now()) {
    const parsed = Date.parse(timestamp);
    if (!Number.isFinite(parsed))
        return false;
    return Math.abs(now - parsed) <= windowSeconds * 1000;
}
function timingSafeEqual(a, b) {
    const left = encoder.encode(a);
    const right = encoder.encode(b);
    if (left.length !== right.length)
        return false;
    let diff = 0;
    for (let i = 0; i < left.length; i += 1) {
        diff |= left[i] ^ right[i];
    }
    return diff === 0;
}
function bytesToHex(bytes) {
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}
function base64UrlEncode(bytes) {
    let binary = "";
    for (const byte of bytes) {
        binary += String.fromCharCode(byte);
    }
    const base64 = typeof btoa === "function"
        ? btoa(binary)
        : Buffer.from(bytes).toString("base64");
    return base64.replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "");
}
//# sourceMappingURL=security.js.map